/**
 * prettyLog 修改默认console
 * @param {*} t
 */

export const prettyLog = {
  ...window.console,
  log(t) {
    const randomColor = `#${`00000${((Math.random() * 0x1000000) << 0).toString(16)}`.substr(-6)}`
    console.log(`%c ${t}`, `color: ${randomColor};font-size: 16px;font-weight: 700;`)
  },
  info(t) {
    this.log(t)
  },
  error(t, n) {
    console.error('Error: %s (%i)', t, n)
  }
}
